<wiz-hgroup #idxZone verticalAlign="center" width="26px" height="20px" style="cursor: pointer; padding-left: 3px; padding-right: 3px;" (click)="goToPage()"><!-- zone indice -->
    <wiz-group horizontalAlign="center" verticalAlign="center" width="100%" height="100%">
      <span
        #blockNum
        class="compute-page"
        width="100%"
        height="100%"
        [style.background-color]="background"
      ></span>
      <wiz-label [wizLabel]="pageOrSymbol" class="smallFont" style="pointer-events: none;"></wiz-label>
    </wiz-group>
  </wiz-hgroup>